// Premium cinematic sign-in background. Single source.
export const SIGNIN_BACKGROUND =
  'https://static.prod-images.emergentagent.com/jobs/d352dee1-97a2-4d0e-af40-463dd534422b/images/555457b7167b1706193568817f66f5c76e766da0fed9b3ebfb09b3d855a7b095.jpeg';

const IMG_BASE =
  'https://static.prod-images.emergentagent.com/jobs/d352dee1-97a2-4d0e-af40-463dd534422b/images/';

// Expanded editorial hero library for the welcome / auth screens. Diverse men —
// ethnicities, ages, seasons, locations, activities. One is picked at random per
// visit (no immediate repeats). Add/replace hashes here to update the set.
const WELCOME_HASHES = [
  'fc0fd3a80379b1e8d6a7f1b6637510a39decb8647e99ed9b26b8ca5dd42fb3c2',
  '4b98b8fff09d57159df685952b2add239724696c9e555981a526dc9d7ddd9363',
  '66526f58222949e4fe0333fde9b4b7be452bd4db8cdbd70738f752cbe8c7240a',
  '93cbb6af5cd79c540c50ac214879c818f648c52299364cefcff81ea0135e2aea',
  '9d8270def573f6c9b5e63e053730232f5dc68c8978548fe938b88c9b8e7769c8',
  '4eb564f411b1ac11875a0bbd43f65e5a03b1051e33a5e3836dc8704d252f2df4',
  'cc26eac0922004e092dba5f110a0c01409bfbbb40c616407246686deec40ac71',
  '8dc6a879cc67b15a25a8c81af262791b3ef8d0889f83c94ffd3324825fdaf880',
  '14ed2c97bc732f1365242677e5fd001917ba2254ec754546acea4d73fc10e7ab',
  'fd371de37dacbf4fbaf35556543f27730631b8f2797207d0240b889d24eff13a',
  'e724c0ca9c69a99ce664f0d90d88ef2b4ef9a9a6c9b7572b682fc71ac8e08e9c',
  'ede348a78eb99a05b223e985193147e894a6d3fafeb240748731bbdebb268166',
  '44d9c16641d54d3034b98976ce78c3f4b42858a04129064ee0bd6adf4927d613',
  'dfa3464a20c02cca7b2d49cc628163691f133580de7fbd1784696145c9c88d1c',
  '6ee463c5788766d6c3573d9487c439c1d9f8412619d00b6663d393039c0ef934',
  'cd74fa6b6a3ba3ab4597d92ee984788a8f538e1e30e504182ec940855943837b',
  'be9a959fd974816a7cfbb952ad47989fd5d1406cb5efa09f485a146b45b95bbe',
  '78ac3f07ea672e67d6eef475d4fd3ef8ccca42a791bd67a32993f5989243ef46',
  '0ae63beca62d783e34d15b6c823ca611843742a02c63125cd201b2a165290d97',
  '3a87d2d5c2eee2ddcc166b01494bcb438d3643b4b2fe89742936c421dc755682',
  '6330f747d75a3978aff27d890187241fb1ebee92c7a1596c914a2b9e8a12c8ec',
  '8c5ed4b6ebb8103318bc0b1dae0a16713935cd9dfa88d8fddedbcbd795c258f4',
  '764573132ee01e4463b062acfec035b0e41db29cd45839033fbd842324f13184',
  '0c6bb785008a448c8b5cf14417c92952bdde1adcc091a71f7b1f77aa481f0ad0',
  '13abbbde5b6d326edbfe514ee5a75bf3f7e3c71a4197051ddb9ad290cdb7959e',
  '166f5e3f5ad08e870da79024422e2b66382dfc0b2686229a254eac7d6e502d30',
  '2cd65b5a3eadbd142c3cd6be04d999e12b9ed9b7506922b9e9a7543847936c21',
  'ad73db1db53b1df76ce96b7f2c4c80282892d4ada1321180f6a94049dd056651',
  'ae61271307092a96a6f00e629113443ee94c2cea2417ef8f609aad5ed15aee8d',
  '61c43a4e8583798d28dc554ae558d7312ae131f2481a7b875a4f8d5954e7078f',
  'b6e9d24bd1385eb99c22f7fb2da3c4689883a3219c0ecc3525c3003539bcf0fd',
  'b39993a9dc4e7fb90f26e974dbd2dd478ab5371805e77ef624b26eaf0c3453aa',
  '3085bce9dcc230fa519fc047904d778c836e4b13eccb909c0fa7ae35fe961463',
  '5dc2059b35fb7c112df5b9e6a6101be2e23c26f115a69ac92feeb9d3aa5d9651',
  '6ebb554e8df4f7bf3861a0a3d66d6df662622aa51b904db9a4fb17303cefecf4',
  '1598fc29f2beaf8135d3524cf822cb6d2a09e81bddf0588edd1c2edad026d99d',
  '9bad009c910fe45d6b6b9e01e4d3c54f38dfc2c41514c5f87aa00b62a05df1a9',
  '0fa03d48b21b039977c8e8e74c0def42593bef6b01022a3175487677c1568bb0',
  'f696ef9a5112edf8d033ee6a85f8b4730d71b88010d748c0f380a51f78c6f1b0',
  'f3a836701d248810d30d8670cfaf689b4f3ebc8742863c2adf6ebc4927e409ae',
  '72dfce0b342486ab02c2b428f47b69c3ee66c3cdf681310dca27c933d2017aa7',
  'c6d48151dcecce51c9d7e9b3936a0701d4b56367711b98160baf02009e7c7257',
  '06c40b15d33b39096dafe4297ff70ae8bd0f3ce76ed11647487f712d6fd7f1b8',
  'fa372320679219ae3d29e766396a9470c1752d695d954a401e7ddae510079f02',
  '4fb3ec5ed329e508bc97ba32732b10cd2566c70edea3ef2ae5671cbbece8911e',
];

export const WELCOME_BACKGROUNDS = WELCOME_HASHES.map((h) => IMG_BASE + h + '.jpeg');

export const WELCOME_BACKGROUND = WELCOME_BACKGROUNDS[0];

// Curated "featured" favorites — the strongest photos. These show ~70% of the
// time; the rest of the library fills the other ~30%. Edit this list to hand-pick.
const FEATURED_HASHES = [
  'cc26eac0922004e092dba5f110a0c01409bfbbb40c616407246686deec40ac71', // canyon hike
  'fc0fd3a80379b1e8d6a7f1b6637510a39decb8647e99ed9b26b8ca5dd42fb3c2', // worship / prayer
  '14ed2c97bc732f1365242677e5fd001917ba2254ec754546acea4d73fc10e7ab', // rooftop breathing
  '9d8270def573f6c9b5e63e053730232f5dc68c8978548fe938b88c9b8e7769c8', // mentorship
  '6ebb554e8df4f7bf3861a0a3d66d6df662622aa51b904db9a4fb17303cefecf4', // suit / city leadership
  '4b98b8fff09d57159df685952b2add239724696c9e555981a526dc9d7ddd9363', // teaching son a tie
  '3085bce9dcc230fa519fc047904d778c836e4b13eccb909c0fa7ae35fe961463', // beach run sunrise
  '66526f58222949e4fe0333fde9b4b7be452bd4db8cdbd70738f752cbe8c7240a', // journaling
  '4eb564f411b1ac11875a0bbd43f65e5a03b1051e33a5e3836dc8704d252f2df4', // cooking with kids
  'cd74fa6b6a3ba3ab4597d92ee984788a8f538e1e30e504182ec940855943837b', // mountain ridge hike
  '93cbb6af5cd79c540c50ac214879c818f648c52299364cefcff81ea0135e2aea', // boxing training
  '0ae63beca62d783e34d15b6c823ca611843742a02c63125cd201b2a165290d97', // marriage / embrace
];
export const FEATURED_BACKGROUNDS = FEATURED_HASHES.map((h) => IMG_BASE + h + '.jpeg');

// Pick a welcome image, weighting the curated favorites, avoiding an immediate repeat.
let _lastWelcome = '';
export const pickWelcomeBackground = () => {
  const useFeatured = FEATURED_BACKGROUNDS.length > 0 && Math.random() < 0.7;
  const pool = useFeatured ? FEATURED_BACKGROUNDS : WELCOME_BACKGROUNDS;
  let pick = pool[Math.floor(Math.random() * pool.length)];
  if (pick === _lastWelcome && pool.length > 1) {
    pick = pool[(pool.indexOf(pick) + 1) % pool.length];
  }
  _lastWelcome = pick;
  return pick;
};
